import { useFormik } from 'formik';
import { PageTitle } from '../../../_metronic/layout/core'
import { v4 as uuidv4 } from 'uuid';
import * as Yup from "yup"
import ZipcodesWithCountry from '../../components/LTLandVolumeTLPages/ZipcodesWithCountry';
import { marginSize } from '../../helpers/marginSize';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { useEffect, useState } from 'react';
import { OriginOrDestinationObject } from '../get-quote/models';
import { UserModel } from '../../modules/auth/models/UserModel';
import { CountryOptions } from '../../data/CountryOptions';
import FreightInformation from '../../components/LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformation';
import Accessorials from '../../components/LTLandVolumeTLPages/AccesorialsComponent/Accessorials';
import PickupAndDelivery from '../../components/NewBookingPage/PickupAndDelivery';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { stylesMUIInput } from '../../components/stylesMUIInput';
import { CircularProgress, IconButton, MenuItem, TextField } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { InputStyled, SelectStyled } from '../../components/Inputs.styled';
import { useStyles } from '../../components/LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles';
import axios from 'axios';
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall';
import { FreightTotals } from '../../components/LTLandVolumeTLPages/FreightInfo/FreightTotals';
import SelectUOM from '../../components/LTLandVolumeTLPages/FreightInfo/SelectUOM';
import StopsModal from '../../components/NewBookingPage/Stops/StopsModal';
import { normalizeParamsVendorRequest } from '../../helpers/normalizeParamsVendorRequest';
import ConfirmNewRequestModal from '../../components/TruckloadRequestPage/ConfirmNewRequestModal';
import { actionTypes } from '../../modules/auth/redux/PagesRedux';
import EditErrorModal from '../../components/TruckloadRequestPage/EditErrorModal';
import VendorRequestCreatedModal from '../../components/TruckloadRequestPage/VendorRequestCreatedModal';
import { format } from 'date-fns';
import ErrorsInPageModal from '../book/NewBooking/ErrorsInPageModal';
import { getCountriesWithoutZipcodes } from '../../constants/countries';

const VENDOR_REQUEST = '/api/v1/vendorrequest'
const ADD_STOPS = '/api/v1/vendorrequest'
interface freightErrors {
    qty: string,
    weight: string,
    nmfc: string,
    L: string,
    W: string,
    H: string
}

const TRUCKTYPES = '/api/v1/system/trucktype'

const SpotQuote = () => {
    const resetValues = useSelector<RootState>(({pages}) => pages?.resetValues) as boolean
    const dispatch = useDispatch()
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    const [origin, setOrigin] = useState<OriginOrDestinationObject>({
        City: "",
        Country: "",
        Name: "",
        State: "",
        Zipcode: "",
        isSL: false,
        isZipcode: false,
        id: null
    })
    const [destination, setDestination] = useState<OriginOrDestinationObject>({
        City: "",
        Country: "",
        Name: "",
        State: "",
        Zipcode: "",
        isSL: false,
        isZipcode: false,
        id: null
    })
    const [zipcodeOrigin, setZipcodeOrigin] = useState('')
    const [zipcodeDestination, setZipcodeDestination] = useState('')
    const [selectedAcc, setSelectedAcc] = useState([]);
    const [actionClicked, setActionClicked] = useState(false)
    const [touchedDate, setTouchedDate] = useState({
        pickup: false,
        delivery: false
    })
    const [equipments, setEquipments] = useState([])
    const [openStopsModal, setOpenStopsModal] = useState(false)
    const [loadingSaveRequest, setLoadingSaveRequest] = useState(false)
    const [openConfirmNewRequestModal, setOpenConfirmNewRequestModal] = useState(false)
    const [vendorRequestNumber, setVendorRequestNumber] = useState('')
    const [editErrorModal, setEditErrorModal] = useState(false)
    const [closeAcc, setCloseAcc] = useState(false)
    const [openVendorRequestCreatedModal, setOpenVendorRequestCreatedModal] = useState(false)
    const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
    const [overrideLength, setOverrideLength] = useState(true)
    const [openErrorsInPageModal, setOpenErrorsInPageModal] = useState(false)
    const [loadingDispatchShipment, setLoadingDispatchShipment] = useState(false)
    const [isAccesorialsOpenend, setIsAccesorialsOpenend ] = useState(false)

    const classes = useStyles({
        fontSize: fontSize
    })
    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }


    const initialValues = {
        stops: {
            serviceType: 'Exclusive',
            stops: [],
            equipment: '',
        },
        origin: {
          City: "",
          Country: "",
          Name: "",
          State: "",
          Zipcode: "",
          isSL: false,
          isZipcode: false,
          id: null
        },
        destination: {
          City: "",
          Country: "",
          Name: "",
          State: "",
          Zipcode: "",
          isSL: false,
          isZipcode: false,
          id: null
        },
        accessorials: {
          origin: [],
          destination: [],
          other: []
        },
        freightInfo: [{
          id: uuidv4(),
          qty: '',
          dimType: {
            name: "PALLET",
            value: "PLT"
          },
          STC: '',
          weight: '',
          each: 'Each',
          L: '',
          W: '',
          H: '',
          class: '',
          commodity: '',
          nmfc: '',
          weightus: '',
          Lus: '',
          Wus: '',
          Hus: '',
          totalCft: '',
          hazmat: false,
          UN: '',
          stack: null,
          volume: ''
        }],
        freightInfoUOM: {
          value: 'US',
          oldValue: ''
        },
        freightInfoTotals: {
          totalPieces: 0,
          totalWeight: 0,
          totalCFT: 0,
          totalDensity: 0,
          symbol: 'lbs'
        },
        insuranceAmount: null,
        insuranceFreight: false,
        insuranceAddOn: false,
        commodityInsurance: '',
        pickupDate: {
            type: 'PickupOn',
            date: null,
            from: null,
            to: null
        },
        deliveryDate: {
            type: 'DeliveryBy',
            date: null,
            from: null,
            to: null
        },
        teamService: false,
        blanketWrap: false,
        instructions: ''
    }


    const validationSchema = (values) => Yup.object().shape({
        origin: Yup.object({
            City: Yup.string().required('Required'),
            Country: Yup.string().required('Required'),
            Name: Yup.string(),
            State: Yup.string().required('Required'),
            Zipcode: getCountriesWithoutZipcodes().includes(values?.origin?.Country) ? Yup.string().nullable() : Yup.string().required('Required'),
            isSL: Yup.boolean(),
            isZipcode: Yup.boolean(),
            isCity: Yup.boolean()
        }),
        destination: Yup.object({
            City: Yup.string().required('Required'),
            Country: Yup.string().required('Required'),
            Name: Yup.string(),
            State: Yup.string().required('Required'),
            Zipcode: getCountriesWithoutZipcodes().includes(values?.destination?.Country) ? Yup.string().nullable() : Yup.string().required('Required'),
            isSL: Yup.boolean(),
            isZipcode: Yup.boolean(),
            isCity: Yup.boolean()
        }),
        freightInfo: Yup.array().of(
            Yup.object().shape({
                qty: Yup.string().required("Required"),
                weight: Yup.string().required("Required"),
                commodity: Yup.string().required("Required"),
                L: Yup.string().required(),
                W: Yup.string().required(),
                H: Yup.string().required(),
                nmfc: Yup.string().test('length', 'Must be 8 numbers or empty', (value) => {
                    if(value && /\s/g.test(value)){
                        return false
                    }else{
                        return true
                    }
                })
            })
        ),
    })

    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        onSubmit: (values) => {
            if(!isNaN(formik?.values?.pickupDate?.date || null) && !isNaN(formik?.values?.deliveryDate?.date || null) && formik?.errors?.pickupDate?.to !== 'Must be after from'){
                let params = normalizeParamsVendorRequest(formik.values)
                let regex = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)
          
                if((regex.test(formik.values?.pickupDate?.from) || !formik.values?.pickupDate?.from) && (regex.test(formik.values.pickupDate.to) || !formik.values?.pickupDate?.to) && (regex.test(formik.values.deliveryDate.from) || !formik.values?.deliveryDate?.from) && (regex.test(formik.values.deliveryDate.to) || !formik.values?.deliveryDate?.to)){
                    setLoadingSaveRequest(true)
                    axios.post(VENDOR_REQUEST, params)
                    .then(results => {
                        setVendorRequestNumber(results?.data?.data?.results?.quoteNumber)
                        setLoadingSaveRequest(false)
                        setOpenVendorRequestCreatedModal(true)
                        if(formik.values?.stops?.stops?.length){
                            addStops(results?.data?.data?.results.VendorQuoteId)
                        }
                    }).catch(error => {
                        setLoadingSaveRequest(false)
                        checkErrorAPICall(error, dispatch, 'Save Request')
                    })
                }
            }else{
                if(isNaN(formik?.values?.pickupDate?.date)){
                    formik.setFieldError('pickupDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
                }
        
                if(isNaN(formik?.values?.deliveryDate?.date)){
                    formik.setFieldError('deliveryDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
                }
            }
        }
    })

    const addStops = (id) => {
        let regexDate = new RegExp(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)
    
        let stops = formik.values?.stops?.stops?.map((stop) => {
            return ({
                "stopNumber": stop?.stopNumber,
                "reference": stop?.reference,
                "pickupDelivery": stop?.type,
                "pickupDeliveryDate": stop?.date ? (!regexDate.test(stop?.date) ? format(stop?.date || null, 'yyyy-MM-dd') : stop?.date) : null,
                "pickupDeliveryTimeFrom": stop?.from,
                "pickupDeliveryTimeTo": stop?.to,
                "name": stop?.name,
                "address1": stop?.address,
                "address2": stop?.address1,
                "city": stop?.city?.includes(',') ? stop?.city?.split(',')[0] : (stop?.city || ''),
                "cityAlias": stop?.city?.includes(',') ? stop?.city?.split(',')[0] : (stop?.city || ''),
                "state": stop?.state,
                "zipcode": stop?.zipcode,
                "country": stop?.country?.length === 2 ? CountryOptions.find(c => c.Code === stop?.country).CodePrimus : stop?.country || 'USA',
                "phone": stop?.phone,
                "fax": "",
                "email": "",
                "contact": stop?.contact,
                "contactPhone": stop?.contactPhone,
                "notes": stop?.notes,
                "PODDate": stop?.PODDate ? (!regexDate.test(stop?.PODDate) ? format(stop?.PODDate || null, 'yyyy-MM-dd') : stop?.PODDate) : null,
                "signedBy": stop.signedBy
            })
        })
    
        axios.post(`${ADD_STOPS}/${id}/stops`, {stops: stops})
    }

    useEffect(() => {
        axios.get(TRUCKTYPES).then(results => {
            setEquipments(results.data.data.results)
          }).catch(error => {
            checkErrorAPICall(error, dispatch, 'Get Truck Types')
        })
    }, [])

    useEffect(() => {
        formik.setFieldValue(`accessorials.origin`, selectedAcc?.filter(acc => acc.category === 'Origin'))
        formik.setFieldValue(`accessorials.destination`, selectedAcc?.filter(acc => acc.category === 'Destination'))
        formik.setFieldValue(`accessorials.other`, selectedAcc?.filter(acc => acc.category === 'Other'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAcc])

    const setDefaultValues = () => {
        ['shipper', 'consignee'].forEach((location) => {
          formik.setFieldValue(location === 'shipper' ? 'origin' : 'destination', {
            City: newBookingValues[location]?.city || '',
            Country: newBookingValues[location]?.country || '',
            Name: newBookingValues[location]?.name || '',
            State: newBookingValues[location]?.state || '',
            Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
            id: newBookingValues[location]?.id || '',
            isPort: false,
            isSL: newBookingValues[location]?.name ? true : false,
            isZipcode: !newBookingValues[location]?.name ? true : false,
            ...formik.values[location === 'shipper' ? 'origin' : 'destination']
          })
    
          if(newBookingValues[location]?.id){
            if(location === 'shipper'){
              setOrigin({
                City: newBookingValues[location]?.city || '',
                Country: newBookingValues[location]?.country?.length > 2 ? CountryOptions?.find(c => c.CodePrimus === newBookingValues[location]?.country)?.Code || "US" : newBookingValues[location]?.country,
                Name: newBookingValues[location]?.name || '',
                State: newBookingValues[location]?.state || '',
                Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
                id: newBookingValues[location]?.id || '',
                isPort: false,
                isSL: newBookingValues[location]?.name ? true : false,
                isZipcode: !newBookingValues[location]?.name ? true : false,
                address1: newBookingValues[location]?.address1,
                address2: newBookingValues[location]?.address2
              })
              setZipcodeOrigin(`${newBookingValues[location]?.name}. ${newBookingValues[location]?.city}, ${newBookingValues[location]?.state} ${newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode}`)
            }else{
              setDestination({
                City: newBookingValues[location]?.city || '',
                Country: newBookingValues[location]?.country?.length > 2 ? CountryOptions?.find(c => c.CodePrimus === newBookingValues[location]?.country)?.Code || "US" : newBookingValues[location]?.country,
                Name: newBookingValues[location]?.name || '',
                State: newBookingValues[location]?.state || '',
                Zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
                id: newBookingValues[location]?.id || '',
                isPort: false,
                isSL: newBookingValues[location]?.name ? true : false,
                isZipcode: !newBookingValues[location]?.name ? true : false,
                address1: newBookingValues[location]?.address1,
                address2: newBookingValues[location]?.address2
              })
              setZipcodeDestination(`${newBookingValues[location]?.name}. ${newBookingValues[location]?.city}, ${newBookingValues[location]?.state} ${newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode}`)
            }
          }
          
          formik.setFieldValue(`freightInfo`, newBookingValues?.freightInfo.length
            ? newBookingValues?.freightInfo
            : [{
              id: uuidv4(),
              qty: '',
              dimType: {
              name: "PALLET",
              value: "PLT"
              },
              STC: '',
              weight: '',
              each: 'Each',
              L: '',
              W: '',
              H: '',
              class: '',
              commodity: '',
              nmfc: '',
              weightus: '',
              Lus: '',
              Wus: '',
              Hus: '',
              totalCft: '',
              hazmat: false,
              UN: ''
            }]
          )
          formik.setFieldValue(`pickupDate`, newBookingValues?.pickupDate)

          let accessorials = []
          if(newBookingValues?.accessorials?.length){
            newBookingValues?.accessorials?.forEach(accessorial => {
              let acc = user.enabledAccessorials.filter(enabledAcc => enabledAcc.code === accessorial)
              accessorials.push(...acc)
            })
          }
      
          formik.setFieldValue(`accessorials.origin`, accessorials.filter(acc => acc.category === 'Origin'))
          formik.setFieldValue(`accessorials.destination`, accessorials.filter(acc => acc.category === 'Destination'))
          formik.setFieldValue(`accessorials.other`, accessorials.filter(acc => acc.category === 'Other'))
          setSelectedAcc(accessorials)
        })
    }

    const clearForm = () => {
        setDefaultValues()
        formik.setFieldValue('deliveryDate.date', null)
        formik.setFieldValue('instructions', '')
        formik.setFieldValue('stops.equipment', [])
        formik.setFieldValue('stops.serviceType', 'Exclusive')
        if(formik?.values?.stops?.length){
            formik.setFieldValue('stops.length', null)
        }
        formik.setFieldValue('stops.stops', [])
        formik.setFieldValue('teamService', false)
        formik.setFieldValue('blanketWrap', false)

        setVendorRequestNumber('')
        setZipcodeOrigin('')
        setZipcodeDestination('')
        setOrigin({
            City: "",
            Country: "",
            Name: "",
            State: "",
            Zipcode: "",
            isSL: false,
            isZipcode: false,
            id: null
        })
        setDestination({
            City: "",
            Country: "",
            Name: "",
            State: "",
            Zipcode: "",
            isSL: false,
            isZipcode: false,
            id: null
        })
    }

    useEffect(() => {
        if(resetValues){
            setOpenConfirmNewRequestModal(true)
            dispatch({type: actionTypes.SetResetValues, payload: false})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetValues])

    useEffect(() => {
        setDefaultValues()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newBookingValues])

    useEffect(() => {
        window.addEventListener('click', (e) => {
          if(e?.target?.id !== 'fieldAccessorials' && !e.target.getAttribute("d")){
            setCloseAcc(true)
          }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <>
            <PageTitle>Spot Quote</PageTitle>
            <form
                onSubmit={formik.handleSubmit}
            >
                <div className="form-group row">
                    {vendorRequestNumber ? <h2 className='mb-2'>#{vendorRequestNumber}</h2> : null}
                    <label className={`col-xl-1 col-form-label ${marginSize(fontSize, 'mt-2','')}`}>Origin</label>
                    <ZipcodesWithCountry
                        formikValues={formik.values.origin}
                        zipcodeLocal={zipcodeOrigin}
                        setZipcodeLocal={setZipcodeOrigin}
                        valueName={'origin'}
                        setDataFormik={formik.setFieldValue}
                        data={origin}
                        setData={setOrigin}
                        countryOptions={CountryOptions}
                        userData={user}
                        error={formik?.errors?.origin?.Zipcode || formik?.errors?.origin?.City}
                        touched={formik?.touched?.origin}
                        setFieldTouched={formik.setFieldTouched}
                        setFieldError={formik.setFieldError}
                        forVendorRequest={true}
                        formDisabled={vendorRequestNumber ? true : false}
                        setOpenClearRateToEditModal={setEditErrorModal}
                    />
                    <label className={`col-xl-1 col-form-label ${marginSize(fontSize, 'mt-2','')}`}>Destination</label>
                    <ZipcodesWithCountry
                        formikValues={formik.values.destination}
                        zipcodeLocal={zipcodeDestination}
                        setZipcodeLocal={setZipcodeDestination}
                        valueName={'destination'}
                        setDataFormik={formik.setFieldValue}
                        data={destination}
                        setData={setDestination}
                        countryOptions={CountryOptions}
                        userData={user}
                        error={formik?.errors?.destination?.Zipcode || formik?.errors?.destination?.City}
                        touched={formik?.touched?.destination}
                        setFieldTouched={formik.setFieldTouched}
                        setFieldError={formik.setFieldError}
                        forVendorRequest={true}
                        formDisabled={vendorRequestNumber ? true : false}
                        setOpenClearRateToEditModal={setEditErrorModal}
                    />
                    {fontSize >= 13 && <div className={`form-group row mt-5`}>
                        <label className="col-12 col-form-label">Freight Info</label>
                    </div>}
                    <div style={{  backgroundColor: 'rgb(228, 230, 239)', borderRadius: '0.475rem',border: '1px solid #E4E6EF', padding: '10px 20px', marginBottom: '10px'}}>
                        {
                            formik.values.freightInfo?.map((freight, index) => {
                                return(
                                    <div className="col-12" key={index}>
                                        <div className={`form-group row align-items-start ${index === formik.values.freightInfo.length - 1 && 'mb-2'}`} key={freight.id}>
                                            {fontSize < 13 && <div className="col-12 col-xl-1">
                                            {index === 0 && <label className="col-form-label">Freight Info</label>}
                                            </div>}
                                            <div className={`${fontSize < 13 ? 'col-12 col-xl-11 mt-5' : 'col-12'}`}>
                                                <div className="row g-0">
                                                    <FreightInformation
                                                        index={index}
                                                        freight={freight}
                                                        freightInfo={formik.values.freightInfo}
                                                        freightInfoUOM={formik.values.freightInfoUOM}
                                                        handleChange={formik.handleChange}
                                                        setDataFormik={formik.setFieldValue}
                                                        formik={formik}
                                                        formikDispatch={formik}
                                                        errors={formik.errors.freightInfo && (formik.errors.freightInfo[index] as freightErrors)}
                                                        touched={formik?.touched?.freightInfo && formik?.touched?.freightInfo[index]}
                                                        dispatchShip={true}
                                                        formDisabled={vendorRequestNumber ? true : false}
                                                        setOpenClearRateToEditModal={setEditErrorModal}
                                                        overrideLength={overrideLength}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="col-12">
                        <div className="row g-0">          
                            <FreightTotals
                                freightInfoTotals={formik?.values?.freightInfoTotals}
                                freightInfo={formik?.values?.freightInfo}
                                freightInfoUOM={formik?.values?.freightInfoUOM}
                                setDataFormik={formik?.setFieldValue}
                            />
                            <SelectUOM
                                freightInfoUOM={formik.values.freightInfoUOM}
                                setDataFormik={formik.setFieldValue}
                                freightInfo={formik.values.freightInfo}
                                freightInfoTotals={formik.values.freightInfoTotals}
                                disabled={vendorRequestNumber ? true : false}
                                readOnly={user?.disableMetricDataEntry}
                            />
                        </div>
                    </div>
                    <div className={`col-12`}>
                        <label className='col-form-label'>Accessorials</label>
                    </div>
                    <div className="col-xl-8 col-sm-12" style={{position: 'relative', marginBottom: isAccesorialsOpenend ? '180px' : '10px' }}>
                        <Accessorials
                            closeAcc={closeAcc}
                            setCloseAcc={setCloseAcc}
                            selectedAcc={selectedAcc}
                            setSelectedAcc={setSelectedAcc}
                            accessorialsList={user?.enabledAccessorials?.filter(accessorial => accessorial.code !== 'HAZ')}
                            formikValues={formik.values}
                            setFormikValues={formik.setFieldValue}
                            forNewBooking={true}
                            formik={formik}
                            forTruckloadRequest={true}
                            actionClicked={actionClicked}
                            formDisabled={vendorRequestNumber ? true : false}
                            setOpenErrorsInPageModal={setOpenErrorsInPageModal}
                            setOpenClearRateToEditModal={setEditErrorModal}
                            setIsAccesorialsOpenend={setIsAccesorialsOpenend}
                        />
                    </div> 
                <div className={`col-6 ${marginSize(fontSize, 'mt-6', 'mt-8')}`}>
                        <label className='col-form-label'>Pickup and Delivery</label>
                        <PickupAndDelivery
                            date='Pickup'
                            setDataFormik={formik.setFieldValue}
                            handleChange={formik.handleChange}
                            error={formik.errors?.pickupDate}
                            values={formik.values.pickupDate}
                            formik={formik}
                            touched={touchedDate}
                            setTouched={setTouchedDate}
                            formDisabled={vendorRequestNumber ? true : false}
                            setEditErrorModal={setEditErrorModal}
                        />
                        <PickupAndDelivery
                            date='Delivery'
                            setDataFormik={formik.setFieldValue}
                            handleChange={formik.handleChange}
                            error={formik.errors?.deliveryDate}
                            values={formik.values.deliveryDate}
                            formik={formik}
                            touched={touchedDate}
                            setTouched={setTouchedDate}
                            formDisabled={vendorRequestNumber ? true : false}
                            setEditErrorModal={setEditErrorModal}
                        />
                    </div>
                    <div className={`col-6 ${marginSize(fontSize, 'mt-6', 'mt-8')} d-flex align-items-center`}>
                        <div className="row">
                            <div className="col-12 col-sm-2 d-flex align-items-center">
                                <label className='col-form-label'>Service type</label>
                            </div>
                            <div className="col-12 col-sm-5 d-flex align-items-center">
                                <SelectStyled
                                    value={formik.values?.stops?.serviceType ? formik.values?.stops?.serviceType : 'Exclusive'}
                                    name='stops.serviceType'
                                    onChange={formik.handleChange} 
                                    className={classes.select}
                                    displayEmpty={true}
                                    inputProps={{
                                        IconComponent: KeyboardArrowDownIcon,
                                        MenuProps: menuProps,
                                        style: stylesMUIInput(fontSize),
                                    }}
                                    style={{
                                        color: '#5E6278',
                                    }}
                                    fontSize={fontSize}
                                    readOnly={vendorRequestNumber ? true : false}
                                    onClick={() => {
                                        if(vendorRequestNumber){
                                            setEditErrorModal(true)
                                        }
                                    }}
                                >
                                    {
                                        ['Exclusive', 'Partial']?.map((stack, index) => {
                                            return <MenuItem key={index} value={stack}>{stack}</MenuItem>
                                        })
                                    }
                                </SelectStyled>
                            </div>
                            <div className="col-12 col-sm-2 d-flex align-items-center">
                                <label className='col-form-label'>Stops</label>
                            </div>
                            <div className="col-12 col-sm-3 d-flex align-items-center">
                                <InputStyled
                                    className="form-control me-1"
                                    readOnly={true}
                                    autoComplete='off'
                                    value={formik.values?.stops?.stops?.length || ''}
                                    fontSize={fontSize}
                                />
                                <div>
                                    <IconButton
                                        onClick={() => {
                                            if(vendorRequestNumber){
                                                setEditErrorModal(true)
                                            }else{
                                                setOpenStopsModal(true)
                                            }
                                        }}
                                    >
                                        <AccessTimeIcon/>
                                    </IconButton>
                                </div>
                            </div>

                            <div className="col-12 col-sm-2 mt-0 mt-sm-4 d-flex align-items-center">
                                <label className='col-form-label'>Equipment</label>
                            </div>
                            <div className="col-12 col-sm-5 mt-0 mt-sm-4 d-flex align-items-center">
                                <TextField
                                    select
                                    label=" "
                                    value={formik.values?.stops?.equipment ? formik.values?.stops?.equipment : []}
                                    name='stops.equipment'
                                    onChange={formik.handleChange}
                                    className={classes.selectMUI}
                                    InputProps={{
                                        style: stylesMUIInput(fontSize),
                                        readOnly: vendorRequestNumber ? true : false
                                    }}
                                    SelectProps={{
                                        IconComponent: KeyboardArrowDownIcon,
                                        MenuProps: menuProps,
                                        multiple: true
                                    }}
                                    InputLabelProps={{shrink: false}}
                                    onClick={() => {
                                        if(vendorRequestNumber){
                                            setEditErrorModal(true)
                                        }
                                    }}
                                >
                                    {
                                        equipments?.map((equipment, index) => {
                                            return <MenuItem key={index} value={equipment.id}>{equipment.name}</MenuItem>
                                        })
                                    }
                                </TextField>
                            </div>
                            <div className="col-12 col-sm-2 mt-0 mt-sm-4 d-flex align-items-center">
                                <label className='col-form-label'>Length</label>
                            </div>
                            <div className="col-12 col-sm-3 d-flex align-items-center mt-0 mt-sm-4">
                                <InputStyled
                                    type="number"
                                    className="form-control me-4"
                                    autoComplete='off'
                                    value={formik?.values?.stops.length === null ? 0 : formik?.values?.stops.length}
                                    onChange={(e) => {
                                        if(e.target.value){
                                            setOverrideLength(false)
                                        }else{
                                            setOverrideLength(true)
                                        }
                                        
                                        formik.setFieldValue('stops.length', e.target.value)
                                    }}
                                    fontSize={fontSize}
                                    readOnly={vendorRequestNumber ? true : false}
                                    onClick={() => {
                                        if(vendorRequestNumber){
                                            setEditErrorModal(true)
                                        }
                                    }}
                                />
                                <div className="me-4">ft.</div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-6">
                        <div className="col-1">
                            <label className='col-form-label'>Instructions</label>
                        </div>
                        <div className="col-9">
                            <textarea
                                style={{height: 60}}
                                className="form-control"
                                rows={2}
                                autoComplete='off'
                                {...formik.getFieldProps('instructions')}
                                readOnly={vendorRequestNumber ? true : false}
                                onClick={() => {
                                    if(vendorRequestNumber){
                                        setEditErrorModal(true)
                                    }
                                }}
                            />
                        </div>
                        <div className="col-2">
                            <div className="form-check form-check-custom form-check-solid mb-2">
                                <input disabled={vendorRequestNumber ? true : false} className="form-check-input" type="checkbox" checked={formik.values.teamService ? true : false} {...formik.getFieldProps('teamService')} name="teamService" id="TeamService"/>
                                <label className="form-check-label" htmlFor="TeamService">
                                    Team Service
                                </label>
                            </div>
                            <div className="form-check form-check-custom form-check-solid">
                                <input disabled={vendorRequestNumber ? true : false} className="form-check-input" type="checkbox" checked={formik.values.blanketWrap ? true : false} {...formik.getFieldProps('blanketWrap')} name="blanketWrap" id="BlanketWrap"/>
                                <label className="form-check-label" htmlFor="BlanketWrap">
                                    Blanket Wrap
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className="col-12 d-flex justify-content-end">
                        <button
                            className='btn btn-primary d-flex align-items-center'
                            type='submit'
                            disabled={vendorRequestNumber ? true : false}
                        >
                            Save Request {loadingSaveRequest && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                        </button>
                    </div>
                </div>
            </form>
            <StopsModal
                open={openStopsModal}
                setOpen={setOpenStopsModal}
                formik={formik}
            />
            <ConfirmNewRequestModal
                open={openConfirmNewRequestModal}
                setOpen={setOpenConfirmNewRequestModal}
                clearForm={clearForm}
            />
            <EditErrorModal
                open={editErrorModal}
                setOpen={setEditErrorModal}
            />
            <VendorRequestCreatedModal
                open={openVendorRequestCreatedModal}
                setOpen={setOpenVendorRequestCreatedModal}
                vendorRequestNumber={vendorRequestNumber}
            />

            <ErrorsInPageModal
                open={openErrorsInPageModal}
                setOpen={setOpenErrorsInPageModal}
                lockedBOL={user.lockedBOL}
                setLoadingDispatchShipment={setLoadingDispatchShipment}
            />
        </>
    )
}

export default SpotQuote